import { trackPromise } from 'react-promise-tracker';
import api from '../../../../../utils/API';
import { CROSS_ELASTICITY_ENGINE_URL, CROSS_ELASTICITY_URL } from '../constants';
import type { ElasticityCurveApiResponse, ElasticityResponse, MarketShareResponse } from '../types';
import { mapApiToElasticityResponse, mapApiToMarketShareResponse } from './transformations';

type GetCurvesParams = {
  productBarcode: string;
  competitorBarcode?: string;
  segmentation?: string;
  subSegmentation?: string;
  region?: string;
};

export type DownloadFormat = 'CSV' | 'XLSX';

export type ElasticityAndMarketShareResult = {
  elasticity: ElasticityResponse;
  marketShare: {
    mapped: MarketShareResponse;
    raw: ElasticityCurveApiResponse;
  };
};

export type MarketShareDataResult = {
  mapped: MarketShareResponse;
  raw: ElasticityCurveApiResponse;
};

const buildGetCurvesPayload = (params: GetCurvesParams) => ({
  productBarcode: params.productBarcode,
  competitorBarcode: params.competitorBarcode,
  ...(params.segmentation && { segmentation: params.segmentation }),
  ...(params.subSegmentation && { subSegmentation: params.subSegmentation }),
  ...(params.region && { region: params.region }),
});

export const getCurves = (params: GetCurvesParams) =>
  trackPromise(
    api({
      url: `${CROSS_ELASTICITY_ENGINE_URL}/api/v1/elasticity/curves`,
      method: 'POST',
      data: buildGetCurvesPayload(params),
      expectToken: true,
    }).then(res => res),
    'elasticidade-cruzada',
  );

export const downloadElasticityCurves = async (format: DownloadFormat, params: GetCurvesParams) =>
  trackPromise(
    api({
      url: `${CROSS_ELASTICITY_URL}/downloads`,
      method: 'POST',
      expectToken: true,
      params: { format },
      data: JSON.stringify(buildGetCurvesPayload(params)),
      responseType: 'arraybuffer',
    }).then(download => {
      if (download.status === 200) {
        const blob = new Blob([download.data]);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = window.URL.createObjectURL(blob);
        hiddenElement.target = '_blank';
        hiddenElement.download = `curva_elasticidade.${format === 'XLSX' ? 'xlsx' : 'csv'}`;
        hiddenElement.click();
      }

      return download;
    }),
    'elasticidade-cruzada',
  );
